# В этом классе описываем все, что относится к работе различных форм
class window.Form
  globalCoAuthorCounter = 0
  
  constructor: ->
    @initInputsInnerLabels()
    @initSelectors()
    @initSelectorsWithInputs()
    @initToggleFormContent()
    @initDataTimePicker()
    @checkDateRange()
    @initGetFilesInput()
    @initAddCoAuthorButton()
    @initSubmitForm()
    @initNoSecondNameCheckbox()
    @getCaptcha()
    
  # Инициализация инпутов с лэйблом внутри их
  initInputsInnerLabels: ->
    inputWrapper = $('.base-input-wrapper--inner-label')
    activeClass = 'base-label--active'

    inputWrapper.click ->
      label = $(this).find('.base-label')
      input = $(this).find('.base-input-text')
      if input[0] != undefined
        label.addClass activeClass
        input.focus()


    inputWrapper.focusout ->
      label = $(this).find('.base-label')
      firstChild = $(this).children()[0]
      childValue = $(firstChild).val()
      if childValue.length == 0
        label.removeClass activeClass


  # Инициализация селекторов
  initSelectors: ->
    $('.base-select').each ->
      unless $(this).hasClass("base-select--with-input")
        selectWrapper = $(this).parent('.base-input-wrapper')
        
        $(this).selectmenu({
          appendTo: selectWrapper
          transferClasses: true
          classes: {
            "ui-selectmenu-menu": "highlight"
          }
          attr: {
            'data-section': $(this).attr('data-section'),
            'data-post': $(this).attr('data-post')
          }
          change: (event, ui) ->
            if $(this).hasClass("js-open-blocks-by-select")
              allTargetBlocks = $('div[data-status]')
              allTargetBlocks.find("input, select").prop("disabled", true)
              allTargetBlocks.hide();
              targetBlock = $('div[data-status="ui-id-'+ui.item.value+'"]')
              targetBlock.find("input, select").prop("disabled", false)
              targetBlock.show()

            if $(ui.item.element).attr('value') == ''
              $('.base-select option').removeAttr('disabled')
              $('.base-select').val('')
              $('.base-select').selectmenu('refresh')

            else if $(this).hasClass("js-addressee-select") # обновление селекторов на изменение получателя
              # обновление органов
              $('.base-select.js-section-select option').each ->
                if $(ui.item.element).data('section') == ''
                  $('.js-section-select').val($(this).attr('value'))
                  return false
                else if Number($(this).attr('value')) == Number($(ui.item.element).data('section')) # && $(this).attr('value') != ''
                  # $(this).attr('disabled', true) 
                # else
                  $('.js-section-select').val($(this).attr('value'))
              
              # обновление должностей
              $('.base-select.js-post-select option').each ->
                if $(ui.item.element).data('post') == ''
                  $('.js-post-select').val($(this).attr('value'))
                  return false
                else if ($(this).attr('value') == $(ui.item.element).data('post')) # && $(this).attr('value') != ''
                #   $(this).attr('disabled', true)
                # else
                  $('.js-post-select').val($(this).attr('value'))
                
              $('.js-section-select').selectmenu('refresh')
              $('.js-post-select').selectmenu('refresh')


            else if $(this).hasClass("js-section-select") # обновление селекторов на изменение органа
              # обновление получателей
              $('.base-select.js-addressee-select option').each ->
                if $(ui.item.element).attr('value') == ''
                  $('.js-addressee-select').val($(this).attr('value'))
                  return false
                # else if Number($(this).data('section')) != Number($(ui.item.element).attr('value')) # && $(this).data('section') != ''
                #   $(this).attr('disabled', true)
                else if Number($(this).data('section')) == Number($(ui.item.element).attr('value'))
                  $('.js-addressee-select').val($(this).attr('value'))

              # обновление должностей
              $('.base-select.js-post-select option').each ->
                sectionPosts = $(ui.item.element).data('post').split(',')

                if $(ui.item.element).attr('value') == ''
                  $('.js-post-select').val($(this).attr('value'))
                  return false
                # else if $.inArray($(this).attr('value'), sectionPosts) == -1
                #   $(this).attr('disabled', true)
                else if $.inArray($(this).attr('value'), sectionPosts) > -1
                  $('.js-post-select').val($(this).attr('value'))
                  # $(this).removeAttr('disabled')
              
              $('.js-addressee-select').selectmenu('refresh')
              $('.js-post-select').selectmenu('refresh')

            else if $(this).hasClass("js-post-select") # обновление селекторов на изменение должности
              # обновление получателей
              $('.base-select.js-addressee-select option').each -> 
                if $(ui.item.element).attr('value') == ''
                  $('.js-addressee-select').val($(this).attr('value'))
                  return false
                # else if $(this).data('post') != $(ui.item.element).attr('value') && $(this).data('post') != ''
                #   $(this).attr('disabled', true)
                else if $(this).data('post') == $(ui.item.element).attr('value')
                  # $(this).removeAttr('disabled')
                  $('.js-addressee-select').val($(this).attr('value'))
              
              # обновление органов
              $('.base-select.js-section-select option').each -> 
                sectionPosts = $(this).data('post').split(',')

                if $(ui.item.element).attr('value') == ''
                  $('.js-section-select').val($(this).attr('value'))
                  return false
                # else if $.inArray($(ui.item.element).attr('value'), sectionPosts) == -1  && $(this).data('post') != ''
                #   $(this).attr('disabled', true)
                else if $.inArray($(ui.item.element).attr('value'), sectionPosts) > -1
                  # $(this).removeAttr('disabled')
                  $('.js-section-select').val($(this).attr('value'))

              $('.js-section-select').selectmenu('refresh')
              $('.js-addressee-select').selectmenu('refresh')
        })

  initSelectorsWithInputs: ->
    $(".base-select--with-input").each ->
      unless $(this).attr("data-select-init") == "true"
        parentContainer = $(this).parent()
        $(this).select2({
          tags: true
          dropdownParent: parentContainer
        })
        $(this).attr("data-select-init", "true")

  # Инициализация частично скрытых форм    
  initToggleFormContent: ->
    hiddenfield = $('.hidden-field');

    $('.js-base-form__button-toggle').click ->
      $('.js-base-form__button-toggle').toggleClass('base-button--turn-icon');
      hiddenfield.slideToggle()


  # Инициализация календаря  
  initDataTimePicker: ->
    $('.js-data-picker').each ->
      unless $(this).attr('data-type') == 'range'
        $(this).datepicker($.datepicker.regional["ru"]);

  # Получение даты из календаря в нужном формате
  getDate: (element) ->
    dateFormat = 'dd.mm.yy'
    try
      date = $.datepicker.parseDate(dateFormat, $(element).val());
    catch error
      date = null
    return date

  # Выбор даты в диапазоне
  checkDateRange: ->
    self = this
    $('.js-data-picker-range').each ->
      start = $(this).find('.js-data-picker--start')
      finish = $(this).find('.js-data-picker--finish')

      start.datepicker(defaultDate: '+1w', changeMonth: true, numberOfMonths: 1).on 'change', ->
        finish.datepicker('option', 'minDate', self.getDate(this))

      finish.datepicker(defaultDate: '+1w', changeMonth: true, numberOfMonths: 1).on 'change', ->
        start.datepicker('option', 'maxDate', self.getDate(this))

  # Инициализация кнопки прикрепления файлов
  initGetFilesInput: ->
    $(".form-file-input").on "change", ->
      $('.file-name').remove()
      realVal = $(this)[0].files
      $('#file_is_attached').val('true')
      i = 0
      while i < realVal.length
        $("<div class=\"file-name\">#{realVal[i].name}</div>")
          .insertBefore('.file-upload-clear-box')
        i++
      return

  initCheckBotInput: (form_id) ->
    $('form[name='+form_id+']').append('<input type="hidden" name="JS_FLAG" value="your_turn">');

  initAddCoAuthorButton: ->
    self = this
    coAuthorCounter = 0
    $(".js-add-co-author").click ->
      coAuthorCounter++
      globalCoAuthorCounter++

      coAuthorHtml = '<div class="co-authors-block" id="co-author-'+coAuthorCounter+'">
                            <div class="co-authors-block__header">
                                <h3 class="base-form-block__title">Соавтор обращения #'+globalCoAuthorCounter+'</h3>
                                <div class="co-authors-block__delete-button link-base-text" data-delete-block="co-author-'+coAuthorCounter+'">Удалить соавтора</div>
                            </div>

                            <p>В электронной анкете в Вашем обращении укажите в именительном падеже Ваши:</p>
                            <label class="base-label" for="CA_'+coAuthorCounter+'__SURNAME"><sup></sup>Фамилия</label>
                            <div class="base-input-wrapper">
                              <input type="text" class="base-input-text base-input--middle" name="CA_'+coAuthorCounter+'__SURNAME" require="require">
                            </div>

                            <label class="base-label" for="CA_'+coAuthorCounter+'__NAME"><sup></sup>Имя</label>
                            <div class="base-input-wrapper">
                              <input class="base-input-text base-input--middle" type="text" name="CA_'+coAuthorCounter+'__NAME" require="require">
                            </div>

                            <label class="base-label" for="CA_'+coAuthorCounter+'__PATRONYMIC">Отчество<br><sub>обязательно,если не стоит галочка Отчество отсутствует</sub></label>
                            <div class="base-input-wrapper">
                              <input class="base-input-text base-input--middle" type="text" name="CA_'+coAuthorCounter+'__PATRONYMIC">
                            </div>

                            <div class="base-input-wrapper">
                              <input type="checkbox" class="base-checkbox" id="CA_'+coAuthorCounter+'__NO_PATRONYMIC" name="CA_'+coAuthorCounter+'__NO_PATRONYMIC" value="Y">
                              <label class="base-label" for="CA_'+coAuthorCounter+'__NO_PATRONYMIC">Отчество отсутствует</label>
                            </div>

                            <label class="base-label" for="CA_'+coAuthorCounter+'__COMPANY_NAME">Наименование организации (юридического лица)</label>
                            <div class="base-input-wrapper">
                              <input class="base-input-text base-input--middle" type="text" name="CA_'+coAuthorCounter+'__COMPANY_NAME">
                            </div>

                            <label class="base-label" for="CA_'+coAuthorCounter+'__EMAIL">Электронная почта
                              <br><sub>адрес электронной почты для получения ответа или уведомления о переадресации обращения</sub></label>
                            <div class="base-input-wrapper">
                              <input class="base-input-text base-input--middle" type="text" name="CA_'+coAuthorCounter+'__EMAIL">
                            </div>
                        </div>
                    </div>'
      $('.js-co-authors-blocks__wrapper').append(coAuthorHtml)
      current_co = $('#CA_ID').val()+coAuthorCounter+','
      $('#CA_ID').val(current_co)
      self.initCoAuthorBlock(coAuthorCounter)
      self.initNoSecondNameCheckbox(coAuthorCounter)

  initCoAuthorBlock: (coAuthorId) ->
    $('[data-delete-block=co-author-'+coAuthorId+']').click ->
      authorBlockId = $(this).attr('data-delete-block')
      $('#'+authorBlockId).remove()
      current_co = $('#CA_ID').val().replace(coAuthorId+',', '')
      $('#CA_ID').val(current_co)

      curCoAuthorCounter = 0
      $('.co-authors-block .base-form-block__title').each ->
        curCoAuthorCounter++
        $(this).html('Соавтор обращения #'+curCoAuthorCounter)

      globalCoAuthorCounter = curCoAuthorCounter

  initSubmitForm: ->
    $this = this
    $(".js-virtual-reception__form").each ->
      unless $(this).attr('data-init') == 'true'
        $(this).attr('data-init', true)
        $(this).submit (event) ->
          window.initSubmitFormFlag = true
          event.preventDefault()
          self = $(this)
          data = new FormData($(this)[0])
          $this.getCaptcha()
          submitBtn = self.find('.js-virtual-reseption')
          submitBtn.attr('disabled', true)

          $.ajax
            url: $(this).attr('action')
            data: data
            dataType: 'html'
            async: false
            cache: false
            contentType: false
            processData: false
            method: 'post'
            success: (result) ->
              $('label.error--custom').remove()
              $('.js-open-gratitude-button').trigger('click')
              submitBtn.attr('disabled', false)
            error: (jqXHR, exception) ->
              submitBtn.attr('disabled', false)
              $('label.error--custom').remove()
              errors = $.parseJSON(jqXHR.responseText)
              $.each errors.ERROR, (key, value) ->
                if (key.includes('CA_'))
                  $('input[name="' + key + '"]').after('<label id="' + key + '-error" class="error--custom">Поле обязательно для заполнения</label>')
                else
                  $('input[name="' + key + '"]').after('<label id="' + key + '-error" class="error--custom">' + value + '</label>')
                  
                  # $('select[name="' + key + '"]').after('<label id="' + key + '-error" class="error">' + value + '</label>');
                  # $('textarea[name="' + key + '"]').after('<label id="' + key + '-error" class="error">' + value + '</label>');

  initNoSecondNameCheckbox: (coAuthorId) ->
    inputName = if coAuthorId then "CA_" + coAuthorId + "__PATRONYMIC" else "PATRONYMIC"
    checkboxName = if coAuthorId then "CA_" + coAuthorId + "__NO_PATRONYMIC" else "NO_PATRONYMIC"
    $('.base-checkbox[name="' + checkboxName + '"]').change ->
      inputSecondName = $(this).parent().parent().find('.base-input-text[name="' + inputName + '"]')
      inputSecondName.val('')
      inputSecondName.prop("disabled", !inputSecondName.prop("disabled"))

  getCaptcha: ->
    $.get '/controllers/get_captcha.php', (data) ->
      $('.catcha_ajax').html data
      return


// WEBPACK FOOTER //
// ./assets/javascripts/app/form.coffee